import {
  computed, onBeforeMount, onMounted, ref,
} from 'vue';
import {mediaQuery} from '../../scripts/lib/mediaQuery';
import EventBus from '../../scripts/lib/EventBus.js';
import {readJsonFromDom} from '../../scripts/utils.js';

const templateElement = document.getElementById('badge-liste-template');
export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    certifiedColumns: {
      type: Array,
      required: false,
    },
    saleFlagContent: {
      type: String,
      required: false,
    },
    active: {
      type: Object,
      required: true,
    },
    previewArticle: {
      type: Object,
      required: false,
    },
    isBuegelleicht: {
      type: Boolean,
      required: false,
    },
  },

  setup(props) {
    const isMobileViewport = ref(mediaQuery.up_to_L);
    const neuFlagData = ref(null);

    const isNew = computed(() => {
      if (props.active.colors) {
        return neuFlagData.value.newItems.includes(props.previewArticle ? props.previewArticle.colors.aktiv.farbId : props.active.colors.aktiv.farbId);
      }
      return neuFlagData.value.newItems.includes(props.active.verkaufId);
    });

    onBeforeMount(() => {
      neuFlagData.value = readJsonFromDom('#entsBadgeData');
      mediaQuery.on('change:width', () => {
        isMobileViewport.value = mediaQuery.up_to_L;
      });
    });

    onMounted(() => {
      EventBus.emit('ents:vue:flags:update', {
        isEasyIron: props.isBuegelleicht,
        isNew: isNew.value
      });
    });

    const openCertifiedDrawer = () => {
      EventBus.emit('ents:vue:certified-columns:drawer:open');
    };

    return {
      isNew,
      isMobileViewport,
      neuFlagData,
      openCertifiedDrawer,
    };
  },
};
